import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';
import { SignupRouting } from './signup.routing';
import { SetupAccountComponent } from './setup-account/setup-account.component';
import { SignupAccountTypeComponent } from './account-type/signup-account-type.component';
import { SetupBillingComponent } from './setup-billing/setup-billing.component';
import { CookieService } from 'ngx-cookie-service';
import { CarouselModule } from 'ngx-bootstrap/carousel';

@NgModule({
  declarations: [
    SignupAccountTypeComponent,
    SetupBillingComponent,
    SetupAccountComponent,
  ],
  exports: [
    SignupAccountTypeComponent,
    SetupBillingComponent,
    SetupAccountComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    SignupRouting,
    CarouselModule.forRoot(),
  ],
  providers: [CookieService],
})
export class SignupModule {
  constructor() {}
}
